// extracted by mini-css-extract-plugin
module.exports = {"list":"SearchBarDropdownList_list__1K_vb","exceptionItemWrapper":"SearchBarDropdownList_exceptionItemWrapper__2Vmus"};